import React from 'react';
import { Reactions } from 'wix-ui-tpa/cssVars';
import { isDefined } from '../../../ts-utils';
import { HAS_REACTION, REACTION_MENU, REACTION_MENU_DATA, REACTION_PENDING, } from '../../data-hooks';
import { defaultReactionsInMenu, resolveMainReactionName } from '../../default-reactions';
import { ReactionIcon } from '../../reaction-icon/reaction-icon';
import { getReactionKeyByName } from '../../utils/get-reaction-key';
import { getReactionCode, getReactionName } from '../../utils/reaction-converters';
import { getValidReactions } from '../../utils/get-valid-reactions';
import { classes, st } from './emotions-button.st.css';
import { noop } from 'lodash';
import cssVars from '../../styles/css-vars.scss';
export const EmotionsButton = ({ className, config, isPending, isMobile, t, isDisabled, onClick, reactions, }) => {
    const validReactions = getValidReactions(reactions, config);
    const activeReaction = validReactions.find((r) => r.hasReacted)?.reactionCode;
    const mainReactionName = resolveMainReactionName(config.mainEmotion);
    const isMainReaction = (reactionName) => reactionName === mainReactionName;
    const popoverReactions = [
        ...(config.emotions ? config.emotions : defaultReactionsInMenu),
    ].filter(isDefined);
    const renderReactionIcon = (reactionName) => {
        const reactionCode = getReactionCode(reactionName, mainReactionName);
        return (React.createElement(ReactionIcon, { className: classes.reactionIcon, dataHook: reactionCode, reactionName: reactionName }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Reactions, { "data-hook": REACTION_MENU, className: st(classes.root, {
                isMobile,
                hasActiveReaction: !!activeReaction,
                isHeartIcon: mainReactionName === 'heart',
                isThumbsUpIcon: mainReactionName === 'thumbsup'
                    ? activeReaction === ':like:'
                    : activeReaction === ':thumbs_up:',
                isThumbsUpIconMain: mainReactionName === 'thumbsup',
            }, cssVars.reactionsContainer, className), defaultReaction: mainReactionName, popoverTriggerAriaLabel: `${t('reaction-button.aria-label')} ${activeReaction
                ? t('reaction-button.aria-label-has-reaction', {
                    reaction: getReactionKeyByName(getReactionName(activeReaction, mainReactionName)),
                })
                : ''}`, onReactionSelect: isDisabled
                ? noop
                : (reactionName) => {
                    if (reactionName) {
                        // select
                        onClick?.(getReactionCode(reactionName, mainReactionName));
                    }
                    else if (activeReaction) {
                        // deselect
                        onClick?.(activeReaction);
                    }
                    else {
                        // skip as there was nothing selected and nothing deselected.
                    }
                }, additionalReactions: popoverReactions, reactionLabel: (reactionName) => isMainReaction(reactionName) ? t('reaction.like') : t(getReactionKeyByName(reactionName)), reactionIcon: renderReactionIcon, selectedId: activeReaction ? getReactionName(activeReaction, mainReactionName) : undefined }),
        React.createElement("span", { "data-hook": `${REACTION_MENU_DATA} ${activeReaction ? HAS_REACTION : ''} ${isPending ? REACTION_PENDING : ''}`, "aria-hidden": "true" })));
};
//# sourceMappingURL=emotions-button.js.map